<template>
  <div id="countries-regime" class="countries-regime">
    <div class="regime_nav flex flex-nowrap p20 items-center bg-gray color--gray-darkest">

      <RegimeIcon :size="30" class="regime_nav__icon flex-none"></RegimeIcon>
      <div class="regime_nav__label flex-auto pr-10 pl-10 color--gray-darkest">
        Countries
      </div>
    </div>
    <ul
            v-bind:key="attribute.id"
            class="attributes__list"
            v-for="attribute in countriesRegime"
    >
      <li class="attributes__list__item">
        <div class="label-wrapper" :class="attribute.class">
          <AttributeLabel
                  @toggleOpen="toggleSectionOpen(attribute.id)"
                  @toggleSelect="toggleSectionOpen(attribute.id)"
                  :open="(currentSection == attribute.id)"
                  :selected="attributeIsSelected(attribute.id)"
                  :identifier="attribute.id"
                  :title="attribute.name"
          ></AttributeLabel>
        </div>
        <transition name="slide">
          <ul v-if="(currentSection == attribute.id)"  class="attributes__list__item__list">
            <router-link
                    class="attributes__list__item__list__item link-item"
                    v-for="subattribute in attribute.countries"
                    tag="li"
                    :to="{ path: '/countries-regions-profile?rsc=[' + subattribute.id + ']' + covidQuery  }"> {{ subattribute.name }}
            </router-link>
          </ul>
        </transition>

      </li><!-- /.attributes__list__item -->
    </ul>
  </div>
</template>

<script>

  import axios from 'axios'
  import RegimeIcon from '../../icons/RegimeIcon'
  import ToggleLabel from '../shared/ToggleLabel'
  import AttributeLabel from './AttributeLabel'
  import Attribute from './Attribute'
  import SelectionMarker from './../shared/SelectionMarker'
  import Regime from './Regime'
  import Vue from 'vue'

  export default {
    name: 'countries-regime',
    components: { Regime, ToggleLabel, Attribute, AttributeLabel, SelectionMarker, RegimeIcon },
    data () {
      return {
        CancelToken: axios.CancelToken,
        cancel () {},
        countriesRegime: {},
        currentSection: false,
        open: false,
        closed: false,
        covidQuery: ''
      }
    },
    computed: {
      countriesRegime () {
        return this.countriesRegime
      }
    },
    watch: {
      covidQuery () {
        return this.covidQuery
      },
      closed () {
        this.open = !this.closed
      },
      open () {
        this.$emit('toggleClosed', !this.open)
      },
      '$store.state.covid19.is_enabled' () {
        if (this.$store.state.covid19.is_enabled) {
          this.covidQuery = '&covid19=1'
        } else {
          this.covidQuery = ''
        }
      }
    },
    mounted () {
      if (this.$store.state.covid19.is_enabled) {
        this.covidQuery = '&covid19=1'
      } else {
        this.covidQuery = ''
      }
      this.open = true
      this.loadData()
    },
    methods: {
      attributeIsSelected (i) {
        i++
        return false
      },
      toggleOpen () {
        this.$emit('toggleOpen', !this.open)
      },
      toggleSelect () {
        this.$emit('toggleSelect', !this.selected)
      },
      loadData (callback) {
        this.$store.dispatch('startFetching', 'countriesRegime')
        this.cancel()
        axios.all([this.fetchData()], {
          cancelToken: new this.CancelToken((c) => {
            this.cancel = c
          })
        })
                .then(axios.spread((response) => {
                  this.$store.dispatch('stopFetching', 'countriesRegime')
                  if (response.data) {
                    this.getCountriesRegime(response.data)
                  }
                  if (callback !== undefined) callback()
                }))
                .catch((error) => {
                  this.$store.dispatch('stopFetching', 'countriesRegime')
                  console.log(error)
                })
      },
      fetchData () {
        return axios.get(process.env.API_URL + 'data?year1=' + this.$store.state.yearSliderCurrent + '&year2=' + this.$store.state.yearSliderCurrent)
      },
      getCountriesRegime (temp) {
        let y = {
          3: {
            name: '',
            class: 'bg--regime-dem-mid',
            countries: []
          },
          1: {
            name: '',
            class: 'bg--regime-orange',
            countries: []
          },
          2: {
            name: '',
            class: 'bg--regime-purple',
            countries: []
          }
        }
        for (let con of temp) {
          let dem = this.$store.getters['rsc/getRegimeById'](con.dem)
          if (dem && dem.name) {
            y[con.dem].id = con.dem
            y[con.dem].name = Vue.filter('fixedName')(dem.name)
            y[con.dem].countries.push({
              id: con.ID_country_code,
              name: Vue.filter('fixedName')(con.ID_country_name)
            })
          }
        }

        y[1].countries.sort((a, b) => { if (a.name < b.name) { return -1 } else if (a.name > b.name) { return 1 } return 0 })
        y[2].countries.sort((a, b) => { if (a.name < b.name) { return -1 } else if (a.name > b.name) { return 1 } return 0 })
        y[3].countries.sort((a, b) => { if (a.name < b.name) { return -1 } else if (a.name > b.name) { return 1 } return 0 })

        this.countriesRegime = y
      },
      toggleSectionOpen (key) {
        if (this.currentSection === key) {
          this.currentSection = false
        } else {
          this.currentSection = key
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~@/components/sass/shared/colors';
  @import '~@/components/sass/shared/fonts';

  .attributes{
    position: relative;
  }

  .attributes__title{
    border-bottom: 1px solid $gray-lighter;
    color: $gray-darker;
    font: 100 19px $fontfamily-serif;
    margin: 0 -20px;
    padding: 0 20px 20px;
  }
  .attributes__title--toggleable{
    cursor: pointer
  }

  .attributes__list{
    list-style-type: none;
    margin: 0;
    padding: 0 20px;
  }

  .attributes__list__item{
    //border-bottom: 1px solid $gray-lighter;
    margin: 0 -20px;
    padding: 20px;
    position: relative;

    &:hover {
      //background: lighten($gray-lighter, 5%);
    }
  }

  .attributes__list__item__selectionmarker{
    position: absolute !important;
    top: 30px;
    left: 6px;
  }

  .subattributes__list__item__list{
    list-style: none;
    margin: 20px 0 0 11px;
    padding: 0;
  }
  .subattributes__list__item__list__item{
    font-size: 13px;
    padding: 15px 0 0;
    position: relative;

    .attribute:not(.isActive){
      color: $gray !important;
    }
  }
  .subattributes__list__item__list__item:first-child{ padding-top: 0 }

  .filtersection{
    display: flex; -js-display: flex;
    font-size: 15px;
    font-weight: 500;
  }

  .filtersection__title{
    flex: 1 1 auto;
  }
  .filtersection__icon{
    align-items: center;
    display: flex; -js-display: flex;
    flex: 1 1 auto;
    justify-content: center;
    max-width: 40px;
  }

  .filtersection__title__help{
    display: inline-block;
    padding-left: 10px;
  }

  .filtersection__toggle{
    align-items: center;
    display: flex; -js-display: flex;
    font-size: 10px;
    flex: 0 0 45px;
    justify-content: flex-end;
    width: 45px;
  }

  .filtersection__icon__image{
    height: 25px;
    padding-right: 15px;
    width: 40px;
  }

  .attributes__list__item__list{
    list-style-type: none;
    margin: 0;
    padding: 0;
  }
  ul.attributes__list__item__list{
    list-style-type: none;
    margin-top: 20px;
    padding: 0;
  }
  .label-wrapper{
    margin:-20px;
    padding:0 20px;
    .attribute-label{
      height:71px;
    }
  }


  .attributes__list__item__list__item{
    padding: 15px 10px 15px 40px;
    position: relative;

    .selectionmarker{
      position: absolute;
      left: 20px;
      top: 20px;
    }

    &:first-child{
      padding-top: 2em;

      .selectionmarker{
        top: 33px;
      }
    }
  }

  .subattributes__list__item__list__item {
    .selectionmarker {
      left: -20px;
      top: 20px;
    }

    &:first-child {
      .selectionmarker {
        top: 5px;
      }
    }
  }

  .selectionmarker{
    position: relative;

  }
  .link-item{
    cursor:pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/navigation/AttributesNavigation/CountriesRegime.vue